export const PaymentTypes = {
    cash: 'cash_on_delivery',
    postCash: 'post_cash_transfer'
}